<mat-tab-group (selectedTabChange)="onTabChange($event)" [selectedIndex]="selectedTabIndex">
    <mat-tab label="Friends{{ total_friends > 0 ? '(' + total_friends + ')' : '' }}">
        <section class="my_friends">
            <ul class="friends-section main-member-list-wrap no-list">
                <li id="friend9" class="member-detail-wrap" *ngFor="let friend of friends">
                    <figure class="img-holder">
                        <a [routerLink]="['/member-profile',friend?.username,'Profile']">
                            <img src="{{friend.profilePicPath}}" class="dsp_img3 iviewed-img" alt="Shawn">
                        </a>
                        <div class="wpee-user-status wpee-online"></div>
                    </figure>
                    <div class="user-details">
                        <h6 class="member-user-name">
                            <a [routerLink]="['/member-profile',friend?.username,'Profile']">{{friend.username}}</a>
                            <span class="online dspdp-online-status">
                                <span class="{{friend.isOnline==true?'dspdp-status-on':'dspdp-status-off'}}"></span>
                            </span>
                        </h6>
                        <div class="user-detail-content">
                            <p>
                                {{friend.age}}
                                <span><fa-icon [icon]="friend?.id === 1 ? famale : fafemale"></fa-icon></span>

                                <span data-label="member-label">
                                    from </span>
                                <br>
                                {{friend?.country?.name}} {{friend?.city?.name}}
                            </p>
                        </div>
                    </div>
                </li>
                <div [ngClass]="{ 'shine': friends_res }">
                </div>
            </ul>
            <div class="profile-section-content" *ngIf="!friends_res && friends.length == 0 && !showErrorMessage">
                <div id="m_list_friend" class="profile-section-content profile-friends-list">
                    <div class="box-border">
                        <div class="box-pedding">
                            <div class="page-not-found">
                                <span class="dsp_span_pointer"
                                    style="text-align: center; display: block; font-weight: bold;">
                                    No Friends Added </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="profile-section-content" *ngIf="!friends_res && friends.length == 0 && showErrorMessage">
                <div id="m_list_friend" class="profile-section-content profile-friends-list">
                    <div class="box-border">
                        <div class="box-pedding">
                            <div class="page-not-found">
                                <span class="dsp_span_pointer"
                                    style="text-align: center; display: block; font-weight: bold;">
                                    Friend list is private. </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </mat-tab>
    <mat-tab label="My Favorites">
        <section class="my_friends favusers">
            <ul class="friends-section main-member-list-wrap no-list">
                <li id="friend9" class="member-detail-wrap" *ngFor="let req of fav_friends">
                    <figure class="img-holder">
                        <a [routerLink]="['/member-profile',req?.username,'Profile']">
                            <img src="{{req.profilePic}}" class="dsp_img3 iviewed-img" alt="Shawn">
                        </a>
                        <div class="wpee-user-status wpee-online"></div>
                    </figure>
                    <div class="user-details">
                        <h6 class="member-user-name">
                            <a [routerLink]="['/member-profile',req?.username,'Profile']">{{req.username}}</a>
                        </h6>
                        <div class="req_btns" *ngIf="is_myProfile">
                            <span class=" req_btn reject" (click)="deleteFav(req.id)"><fa-icon
                                    [icon]='this.fatrash'></fa-icon></span>
                        </div>
                    </div>
                </li>
                <div [ngClass]="{ 'shine': fav_friends_res }">
                </div>
            </ul>
            <div class="profile-section-content" *ngIf="!fav_friends_res && fav_friends.length == 0">
                <div id="m_list_friend" class="profile-section-content profile-friends-list">
                    <div class="box-border">
                        <div class="box-pedding">
                            <div class="page-not-found">
                                <span class="dsp_span_pointer"
                                    style="text-align: center; display: block; font-weight: bold;">
                                    No Favorites Added </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </mat-tab>
    <mat-tab label="Friend Requests" *ngIf="is_myProfile">
        <section class="my_friends req_frieds">
            <ul class="friends-section main-member-list-wrap no-list">
                <li id="friend9" class="member-detail-wrap" *ngFor="let req of requestPending">
                    <figure class="img-holder">
                        <a [routerLink]="['/member-profile',req?.username,'Profile']">
                            <img src="{{req.profilePic}}" class="dsp_img3 iviewed-img" alt="Shawn">
                        </a>
                        <div class="wpee-user-status wpee-online"></div>
                    </figure>
                    <div class="user-details">
                        <h6 class="member-user-name">
                            <a>{{req.username}}</a>
                        </h6>
                    </div>
                    <div class="req_btns">
                        <span class=" req_btn reject" (click)="cacelRequest(req.sender)"><fa-icon
                                [icon]='this.faCancel'></fa-icon></span>
                        <span class=" req_btn accept" (click)="acceptRequest(req.sender)"><fa-icon
                                [icon]='this.faCheck'></fa-icon></span>
                    </div>
                </li>
                <div [ngClass]="{ 'shine': isLoading }">
                </div>
            </ul>
            <div class="profile-section-content" *ngIf="!isLoading && requestPending.length == 0">
                <div id="m_list_friend" class="profile-section-content profile-friends-list">
                    <div class="box-border">
                        <div class="box-pedding">
                            <div class="page-not-found">
                                <span class="dsp_span_pointer"
                                    style="text-align: center; display: block; font-weight: bold;">
                                    No Request Added </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </mat-tab>
</mat-tab-group>